import "/src/output.css";
import "./loading-bar";
import "./loading-bar.css";
import * as dat from "dat.gui";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import Stats from "stats.js";

/**
 * Base
 */
// Debug
const gui = new dat.GUI({
  width: 300,
  closed: true,
});
const loadElement = document.getElementById("loadContainer");
let bar1 = new ldBar("#loadProgress");
const loadManager = new THREE.LoadingManager(
  () => {
    setTimeout(() => {
      loadElement.classList.add("hidden");
    }, 2000);
  },
  (url, loaded, total) => {
    const progressRatio = (loaded / total) * 100;
    bar1.set(progressRatio);
  }
);
//Fps
const stats = new Stats();
stats.showPanel(0);
const fpsCon = document.querySelector("#fps");
const fpsToggle = {
  show: false,
};
const fpsToggleCheck = () => {
  if (fpsToggle.show === false) {
    fpsCon.removeChild(stats.dom);
  } else {
    fpsCon.appendChild(stats.dom);
  }
};
gui.add(fpsToggle, "show").name("fps харуулах").onChange(fpsToggleCheck);
// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

/**
 * Loaders
 */
// Texture loader
const textureLoader = new THREE.TextureLoader(loadManager);

// Draco loader
const dracoLoader = new DRACOLoader(loadManager);
dracoLoader.setDecoderPath("draco/");

// GLTF loader
const gltfLoader = new GLTFLoader(loadManager);
gltfLoader.setDRACOLoader(dracoLoader);

// Sounds
const sounds = [
  new Audio("/sounds/sun.mp3"),
  new Audio("/sounds/mercury.mp3"),
  new Audio("/sounds/venus.mp3"),
  new Audio("/sounds/earth.mp3"),
  new Audio("/sounds/moon.mp3"),
  new Audio("/sounds/mars.mp3"),
  new Audio("/sounds/jupiter.mp3"),
  new Audio("/sounds/saturn.mp3"),
  new Audio("/sounds/uranus.mp3"),
  new Audio("/sounds/neptune.mp3"),
  new Audio("/sounds/pluto.mp3"),
  new Audio("/sounds/solarsystem.mp3"),
];
const playSounds = {
  playSun: () => {
    sounds[0].play();
  },
  playMercury: () => {
    sounds[1].play();
  },
  playVenus: () => {
    sounds[2].play();
  },
  playEarth: () => {
    sounds[3].play();
  },
  playMoon: () => {
    sounds[4].play();
  },
  playMars: () => {
    sounds[5].play();
  },
  playJupiter: () => {
    sounds[6].play();
  },
  playSaturn: () => {
    sounds[7].play();
  },
  playUranus: () => {
    sounds[8].play();
  },
  playNeptune: () => {
    sounds[9].play();
  },
  playPluto: () => {
    sounds[10].play();
  },
  playSolarSystem: () => {
    sounds[11].play();
  },
};

// Stars
const starTexture = textureLoader.load("/img/starmap.png");
const starParameter = {
  count: 3000,
  speed: 0.001,
};
let starsGeometry = null;
let starsMaterial = null;
let stars = null;
const GenerateStars = () => {
  if (stars !== null) {
    starsGeometry.dispose();
    starsMaterial.dispose();
    scene.remove(stars);
  }
  starsGeometry = new THREE.BufferGeometry();
  starsMaterial = new THREE.PointsMaterial({
    size: 1,
    sizeAttenuation: true,
    alphaMap: starTexture,
    transparent: true,
  });
  const starsPositions = new Float32Array(starParameter.count * 3);
  for (let i = 0; i < starParameter.count * 3; i++) {
    starsPositions[i] = (Math.random() - 0.5) * 500;
  }
  starsGeometry.setAttribute(
    "position",
    new THREE.BufferAttribute(starsPositions, 3)
  );
  stars = new THREE.Points(starsGeometry, starsMaterial);
  scene.add(stars);
};
GenerateStars();
gui
  .add(starParameter, "count", 1000, 8000, 100)
  .name("Оддын тоо")
  .onChange(GenerateStars);
gui.add(starParameter, "speed", 0, 0.005, 0.00001).name("Тойрох хурд");

// Planet textures
const sunTexture = textureLoader.load("/img/sun.jpg");
const mercuryTexture = textureLoader.load("/img/mercurymap.jpg");
const venusTexture = textureLoader.load("/img/venusmap.jpg");
const earthTexture = textureLoader.load("/img/earthmap.jpg");
const moonTexture = textureLoader.load("/img/moonmap.jpg");
const marsTexture = textureLoader.load("/img/marsmap.jpg");
const jupiterTexture = textureLoader.load("/img/jupitermap.jpg");
const saturnTexture = textureLoader.load("/img/saturnmap.jpg");
const saturnRingTexture = textureLoader.load("/img/saturnring.jpg");
const uranusTexture = textureLoader.load("/img/uranusmap.jpg");
const uranusRingTexture = textureLoader.load("/img/uranusring1.png");
const neptuneTexture = textureLoader.load("/img/neptunemap.jpg");
const plutoTexture = textureLoader.load("/img/plutomap.jpg");
/**
 * Object planets
 */
// Create planet function
function createPlanet(size, texture, position) {
  const planet = new THREE.Mesh(
    new THREE.SphereGeometry(size, 25, 25),
    new THREE.MeshBasicMaterial({ map: texture })
  );
  planet.position.x = position;
  return planet;
}
// Create ring function
function createRing(innerSize, outerSize, texture, position) {
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(innerSize, outerSize, 25),
    new THREE.MeshBasicMaterial({
      map: texture,
      side: THREE.DoubleSide,
    })
  );
  ring.position.x = position;
  ring.rotation.x = -Math.PI * 0.5;
  return ring;
}
// Create line function
function createOrbitLine(centerX, centerY, radiusX, radiusY, color) {
  const points = new THREE.EllipseCurve(
    centerX,
    centerY,
    radiusX,
    radiusY,
    0,
    2 * Math.PI
  ).getSpacedPoints(64);
  const orbitLine = new THREE.Line(
    new THREE.BufferGeometry().setFromPoints(points),
    new THREE.LineBasicMaterial({ color: color })
  );
  orbitLine.rotateX(-Math.PI * 0.5);
  return orbitLine;
}
// Planet groups
const solarSystemGroup = new THREE.Group();
const mercuryOrbit = new THREE.Group();
const venusOrbit = new THREE.Group();
const earthOrbit = new THREE.Group();
const moonOrbit = new THREE.Group();
const marsOrbit = new THREE.Group();
const jupiterOrbit = new THREE.Group();
const saturnOrbit = new THREE.Group();
const uranusOrbit = new THREE.Group();
const neptuneOrbit = new THREE.Group();
const plutoOrbit = new THREE.Group();
//Sun
const sun = createPlanet(10, sunTexture, 0);
solarSystemGroup.add(sun);

//Mercury
const mercury = createPlanet(1, mercuryTexture, 20);
mercuryOrbit.add(mercury);
solarSystemGroup.add(createOrbitLine(0, 0, 20, 20, 0xffffff));

//Venus
const venus = createPlanet(1, venusTexture, -30);
venusOrbit.add(venus);
solarSystemGroup.add(createOrbitLine(0, 0, -30, -30, 0xffffff));

//Earth
const earth = createPlanet(2, earthTexture, 40);
earthOrbit.add(earth);
solarSystemGroup.add(createOrbitLine(0, 0, 40, 40, 0xffffff));

//Moon
const moon = createPlanet(1, moonTexture, 4);
moonOrbit.add(moon);
moonOrbit.position.x = 40;
earthOrbit.add(moonOrbit);
earthOrbit.add(createOrbitLine(40, 0, 4, 4, 0xffffff));

//Mars
const mars = createPlanet(1, marsTexture, -50);
marsOrbit.add(mars);
solarSystemGroup.add(createOrbitLine(0, 0, -50, -50, 0xffffff));

//Jupiter
const jupiter = createPlanet(5, jupiterTexture, 60);
jupiterOrbit.add(jupiter);
solarSystemGroup.add(createOrbitLine(0, 0, 60, 60, 0xffffff));

//Saturn
const saturn = createPlanet(4.5, saturnTexture, -80);
const saturnRing = createRing(5.5, 8.5, saturnRingTexture, -80);
saturnRing.rotation.y = Math.PI * 0.14;
saturn.rotation.z = -Math.PI * 0.14;
saturnOrbit.add(saturn, saturnRing);
solarSystemGroup.add(createOrbitLine(0, 0, -80, -80, 0xffffff));

//Uranus
const uranus = createPlanet(3, uranusTexture, 100);
const uranusRing = createRing(4, 6, uranusRingTexture, 100);
uranusRing.rotation.y = Math.PI * 0.54;
uranusOrbit.add(uranus, uranusRing);
solarSystemGroup.add(createOrbitLine(0, 0, 100, 100, 0xffffff));

//Neptune
const neptune = createPlanet(3, neptuneTexture, -115);
neptuneOrbit.add(neptune);
solarSystemGroup.add(createOrbitLine(0, 0, -115, -115, 0xffffff));

//Pluto
const pluto = createPlanet(1, plutoTexture, 125);
plutoOrbit.add(pluto);
plutoOrbit.rotation.x = Math.PI * 0.09;
const plutoLine = createOrbitLine(0, 0, 125, 125, 0xffffff);
plutoLine.rotation.x = -Math.PI * 0.41;
solarSystemGroup.add(plutoLine);

scene.add(
  solarSystemGroup,
  mercuryOrbit,
  venusOrbit,
  earthOrbit,
  marsOrbit,
  jupiterOrbit,
  saturnOrbit,
  uranusOrbit,
  neptuneOrbit,
  plutoOrbit
);

/**
 * Sizes
 */
const can = document.querySelector("#canvasContainer");
const sizes = {
  height: can.offsetHeight,
  width: can.offsetWidth,
};
/**
 *  Fullscreen & click disable
 */
const halfScreenSet = () => {
  sizes.height = can.offsetHeight;
  sizes.width = can.offsetWidth;
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
};
const fullScreenSet = () => {
  sizes.height = window.innerHeight;
  sizes.width = window.innerWidth;
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
};
var isFullScreen = false;
var clickEnabled = true;
const hideElements = document.querySelectorAll(".hide");
const fullWindowBtn = document.getElementById("full");
fullWindowBtn.onclick = function fullScreen() {
  switch (fullWindowBtn.innerHTML) {
    case "Full Window":
      isFullScreen = true;
      hideElements.forEach((el) => {
        el.classList.add("nonvisible");
      });
      document.body.addEventListener("click", (e) => {
        if (clickEnabled === false) {
          e.stopPropagation();
          e.preventDefault();
        }
        clickEnabled = false;
      });
      fullScreenSet();
      fullWindowBtn.innerHTML = "Half Window";
      break;
    case "Half Window":
      isFullScreen = false;
      hideElements.forEach((el) => {
        if (el.classList.contains("lastelement")) {
          el.classList.remove("nonvisible");
        }
        if (el.id === "back") {
          el.classList.remove("nonvisible");
        }
        if (el.id === "about") {
          el.classList.remove("nonvisible");
        }
      });
      document.body.addEventListener("click", (e) => {
        clickEnabled = true;
      });
      halfScreenSet();
      fullWindowBtn.innerHTML = "Full Window";
      break;
  }
};
window.addEventListener("resize", () => {
  if (isFullScreen) {
    fullScreenSet();
  } else {
    halfScreenSet();
  }
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  45,
  sizes.width / sizes.height,
  0.1,
  1000
);
camera.position.set(170, 30, 60);
scene.add(camera);

/**
 *  Html objects
 */
const htmlObject = [
  document.querySelector("#system-h1"), //0 system
  document.querySelector("#system-p"), //1
  document.querySelector("#sun-h1"), //2 sun
  document.querySelector("#sun-p"), //3
  document.querySelector("#mercury-h1"), //4 mercury
  document.querySelector("#mercury-p"), //5
  document.querySelector("#venus-h1"), //6 venus
  document.querySelector("#venus-p"), //7
  document.querySelector("#earth-h1"), //8 earth
  document.querySelector("#earth-p"), //9
  document.querySelector("#moon-h1"), //10 moon
  document.querySelector("#moon-p"), //11
  document.querySelector("#mars-h1"), //12 mars
  document.querySelector("#mars-p"), //13
  document.querySelector("#jupiter-h1"), //14 jupiter
  document.querySelector("#jupiter-p"), //15
  document.querySelector("#saturn-h1"), //16 saturn
  document.querySelector("#saturn-p"), //17
  document.querySelector("#uranus-h1"), //18 uranus
  document.querySelector("#uranus-p"), //19
  document.querySelector("#neptune-h1"), //20 neptune
  document.querySelector("#neptune-p"), //21
  document.querySelector("#pluto-h1"), //22 pluto
  document.querySelector("#pluto-p"), //23
  document.getElementById("sunPng"), //24
  document.getElementById("mercuryPng"), //25
  document.getElementById("venusPng"), //26
  document.getElementById("earthPng"), //27
  document.getElementById("moonPng"), //28
  document.getElementById("marsPng"), //29
  document.getElementById("jupiterPng"), //30
  document.getElementById("saturnPng"), //31
  document.getElementById("uranusPng"), //32
  document.getElementById("neptunePng"), //33
  document.getElementById("plutoPng"), //34
  document.getElementById("solarsystemPng"), //35
];
const backButton = document.querySelector("#back");
backButton.addEventListener("click", () => {
  clearHtml();
  htmlObject[0].classList.remove("nonvisible");
  htmlObject[1].classList.remove("nonvisible");
  htmlObject[0].classList.add("lastelement");
  htmlObject[1].classList.add("lastelement");
  htmlObject[35].classList.add("lg:inline");
  playSounds.playSolarSystem();
});
const clearHtml = () => {
  htmlObject.forEach((el) => {
    el.classList.add("nonvisible");
    el.classList.remove("lastelement");
    el.classList.remove("lg:inline");
  });
};
/**
 *  Raycaster
 */
const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();
window.addEventListener("mousemove", (event) => {
  mouse.x = (event.clientX / sizes.width) * 2 - 1;
  mouse.y = -(event.clientY / sizes.height) * 2 + 1;
});
window.addEventListener("click", () => {
  if (currentIntersect) {
    switch (currentIntersect.object) {
      case sun:
        clearHtml();
        htmlObject[2].classList.remove("nonvisible");
        htmlObject[3].classList.remove("nonvisible");
        htmlObject[2].classList.add("lastelement");
        htmlObject[3].classList.add("lastelement");
        htmlObject[24].classList.add("lg:inline");
        playSounds.playSun();

        break;
      case mercury:
        clearHtml();
        htmlObject[4].classList.remove("nonvisible");
        htmlObject[5].classList.remove("nonvisible");
        htmlObject[4].classList.add("lastelement");
        htmlObject[5].classList.add("lastelement");
        htmlObject[25].classList.add("lg:inline");
        playSounds.playMercury();
        break;
      case venus:
        clearHtml();
        htmlObject[6].classList.remove("nonvisible");
        htmlObject[7].classList.remove("nonvisible");
        htmlObject[6].classList.add("lastelement");
        htmlObject[7].classList.add("lastelement");
        htmlObject[26].classList.add("lg:inline");
        playSounds.playVenus();
        break;
      case earth:
        clearHtml();
        htmlObject[8].classList.remove("nonvisible");
        htmlObject[9].classList.remove("nonvisible");
        htmlObject[8].classList.add("lastelement");
        htmlObject[9].classList.add("lastelement");
        htmlObject[27].classList.add("lg:inline");
        playSounds.playEarth();
        break;
      case moon:
        clearHtml();
        htmlObject[10].classList.remove("nonvisible");
        htmlObject[11].classList.remove("nonvisible");
        htmlObject[10].classList.add("lastelement");
        htmlObject[11].classList.add("lastelement");
        htmlObject[28].classList.add("lg:inline");
        playSounds.playMoon();
        break;
      case mars:
        clearHtml();
        htmlObject[12].classList.remove("nonvisible");
        htmlObject[13].classList.remove("nonvisible");
        htmlObject[12].classList.add("lastelement");
        htmlObject[13].classList.add("lastelement");
        htmlObject[29].classList.add("lg:inline");
        playSounds.playMars();
        break;
      case jupiter:
        clearHtml();
        htmlObject[14].classList.remove("nonvisible");
        htmlObject[15].classList.remove("nonvisible");
        htmlObject[14].classList.add("lastelement");
        htmlObject[15].classList.add("lastelement");
        htmlObject[30].classList.add("lg:inline");
        playSounds.playJupiter();
        break;
      case saturn:
        clearHtml();
        htmlObject[16].classList.remove("nonvisible");
        htmlObject[17].classList.remove("nonvisible");
        htmlObject[16].classList.add("lastelement");
        htmlObject[17].classList.add("lastelement");
        htmlObject[31].classList.add("lg:inline");
        playSounds.playSaturn();
        break;
      case uranus:
        clearHtml();
        htmlObject[18].classList.remove("nonvisible");
        htmlObject[19].classList.remove("nonvisible");
        htmlObject[18].classList.add("lastelement");
        htmlObject[19].classList.add("lastelement");
        htmlObject[32].classList.add("lg:inline");
        playSounds.playUranus();
        break;
      case neptune:
        clearHtml();
        htmlObject[20].classList.remove("nonvisible");
        htmlObject[21].classList.remove("nonvisible");
        htmlObject[20].classList.add("lastelement");
        htmlObject[21].classList.add("lastelement");
        htmlObject[33].classList.add("lg:inline");
        playSounds.playNeptune();
        break;
      case pluto:
        clearHtml();
        htmlObject[22].classList.remove("nonvisible");
        htmlObject[23].classList.remove("nonvisible");
        htmlObject[22].classList.add("lastelement");
        htmlObject[23].classList.add("lastelement");
        htmlObject[34].classList.add("lg:inline");
        playSounds.playPluto();
        break;
    }
  }
});
// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;
controls.enablePan = false;
controls.rotateSpeed = 0.4;
controls.maxDistance = 500;
controls.minDistance = 40;
controls.minPolarAngle = -Math.PI * 0.5;
controls.maxPolarAngle = Math.PI * 0.44;
/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  antialias: true,
});
renderer.setSize(can.offsetWidth, can.offsetHeight);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Animate
 */
const clock = new THREE.Clock();
let currentIntersect = null;
const tick = () => {
  stats.begin();
  const elapsedTime = clock.getElapsedTime();

  //Animate planets
  {
    sun.rotateY(-starParameter.speed);
    mercuryOrbit.rotateY(starParameter.speed);
    venusOrbit.rotateY(starParameter.speed + 0.0005);
    earthOrbit.rotateY(starParameter.speed);
    earth.rotateY(starParameter.speed * 2);
    moonOrbit.rotateY(-(starParameter.speed + 0.004));
    marsOrbit.rotateY(starParameter.speed + 0.0005);
    jupiterOrbit.rotateY(starParameter.speed - 0.0002);
    saturnOrbit.rotateY(starParameter.speed - 0.0001);
    uranusOrbit.rotateY(starParameter.speed - 0.0003);
    neptuneOrbit.rotateY(starParameter.speed - 0.0006);
    plutoOrbit.rotateY(starParameter.speed - 0.0001);
  }

  raycaster.setFromCamera(mouse, camera);
  const objectsToTest = [
    sun,
    mercury,
    venus,
    earth,
    moon,
    mars,
    jupiter,
    saturn,
    uranus,
    neptune,
    pluto,
  ];
  const intersects = raycaster.intersectObjects(objectsToTest);
  // }
  if (intersects.length) {
    if (currentIntersect === null) {
      document.body.style.cursor = "pointer";
    }
    currentIntersect = intersects[0];
  } else {
    if (currentIntersect) {
      document.body.style.cursor = "default";
    }
    currentIntersect = null;
  }
  // Update controls
  controls.update();
  // Render
  renderer.render(scene, camera);
  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
  stats.end();
};
tick();
